import React from "react";
import { useSelector } from "react-redux";
import { hasAccess } from "../app/Utils/Utils";
import { PERMISIONS } from "../app/Utils/CONST";

const useAccessControl = () => {
  const { user_feature_map: accessMap, ADMINRIGHTS: adminRights } = useSelector(
    (state) => state?.auth?.selectedHotel?.accessControl
  );

  return {
    canRead: (feature) => hasAccess(accessMap, feature, PERMISIONS.READ),
    canAdd: (feature) => hasAccess(accessMap, feature, PERMISIONS.ADD),
    canUpdate: (feature) => hasAccess(accessMap, feature, PERMISIONS.UPDATE),
    canDelete: (feature) => hasAccess(accessMap, feature, PERMISIONS.DELETE),
    adminRights,
  };
};

export default useAccessControl;
